import { Realtime } from 'ably';
import { useEffect } from 'react';
import { store } from '../..';
declare var REALTIME_KEY: string;

const client = new Realtime({ key: REALTIME_KEY });
/**
 * Uses realtime service to watch messages and send them to redux
 */
export function useRealtime(channelName: string | string[]) {
  useEffect(() => {
    console.info('UPDATING REALTIME', channelName);
    const channelNames = Array.isArray(channelName) ? channelName : [channelName];
    const channels = channelNames.map(name => client.channels.get(name));

    //const channel = clientRef.current.channels.get(channelName);

    channels.forEach(channel => {
      channel.subscribe(message => {
        console.log(message);

        if (message.data && message.data.type) {
          store.dispatch(message.data);
        }
      });
    });

    return () => {
      channels.forEach(channel => {
        channel.unsubscribe();
      });
    };
  }, [channelCompareFunc(channelName)]);
}

const channelCompareFunc = (channelName: string | string[]): string => {
  if (Array.isArray(channelName)) {
    return [...channelName].sort().join(',');
  }
  return channelName;
};
